import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'ftPlaceholder',
    standalone: false
})
export class PlaceholderPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {
    }

    transform(value: any, text: string = 'Click to edit'): SafeHtml {
        if (typeof value === 'undefined' || value === null || value === '' || value?.length === 0) {
            // A null `text` degrades to the generic prompt as well, not just an omitted one. A default
            // parameter only fires on undefined, and Angular compiles `a?.b` to `a == null ? null : a.b`
            // — so a caller passing a safe-navigated placeholder hands this NULL the moment the object
            // is missing, and without this the row rendered the literal string "null" at the hotelier.
            return this.sanitizer.bypassSecurityTrustHtml(`<span class="muted-text">${text ?? 'Click to edit'}</span>`)
        }
        return value;
    }
}
